export const fieldForgotPasswordEmail = {
    classNameInputWrapper: 'forgot-password-input',
    name: 'forgot-password-email',
    nickname: 'Email',
    type: 'text',
    label: 'E-Mail',
    hasborder: 'no',
    required: false,
  };